import type { GetBrandsResponseType } from "@nlc/shared-types";
import type { DefaultError } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { brandsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export type BrandSelectOption = GetBrandsResponseType["brands"][number];

export function useGetBrandsByProjectId(projectId?: number) {
  return useQuery<BrandSelectOption[], DefaultError>({
    enabled: !!projectId,
    queryFn: async () => {
      const { brands } = await apiClient
        .url(`/brands?projectId=${projectId}`)
        .get()
        .json<GetBrandsResponseType>();

      return brands;
    },
    queryKey: brandsKeys.brandsByProjectId(projectId),
  });
}
